import { AdminWordService } from "./AdminWordService";
import { FirebaseAdminWordService } from "./firebase/FirebaseAdminWordService";
import { SupabaseAdminWordService } from "./supabase/SupabaseAdminWordService";

export type AdminWordServiceType = "firebase" | "supabase";

/**
 * Convenience functions for creating admin services with proper method binding
 */
export const createAdminWordService = {
  firebase: (): AdminWordService => {
    const service = new FirebaseAdminWordService();
    // Ensure all methods are properly bound to avoid context issues
    return {
      addWord: service.addWord.bind(service),
      updateWord: service.updateWord.bind(service),
      deleteWord: service.deleteWord.bind(service),
      renameWord: service.renameWord.bind(service),
      exportWords: service.exportWords.bind(service),
      addChange: service.addChange.bind(service),
      getWord: service.getWord.bind(service),
      searchImages: service.searchImages.bind(service),
    } as AdminWordService;
  },

  supabase: (): AdminWordService => {
    const service = new SupabaseAdminWordService();
    // Ensure all methods are properly bound to avoid context issues
    return {
      addWord: service.addWord.bind(service),
      updateWord: service.updateWord.bind(service),
      deleteWord: service.deleteWord.bind(service),
      renameWord: service.renameWord.bind(service),
      exportWords: service.exportWords.bind(service),
      addChange: service.addChange.bind(service),
      getWord: service.getWord?.bind(service),
      searchImages: service.searchImages.bind(service),
    } as AdminWordService;
  },
};
